import { render, staticRenderFns } from "./woodStatistic.vue?vue&type=template&id=b660ddf8&scoped=true&"
import script from "./woodStatistic.vue?vue&type=script&lang=js&"
export * from "./woodStatistic.vue?vue&type=script&lang=js&"
import style0 from "./woodStatistic.vue?vue&type=style&index=0&id=b660ddf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b660ddf8",
  null
  
)

export default component.exports